import { getApiOrigin } from '../config/environment';

export function resolveDeliveryCarrierLogoUrl(logoUrl?: string | null): string {
  const raw = (logoUrl || '').trim();
  if (!raw) return '';
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  const origin = getApiOrigin();
  return `${origin}${raw.startsWith('/') ? raw : `/${raw}`}`;
}
